module.exports = __webpack_public_path__ + "img/四川天府新区永兴中学.c9d6c6a7.jpg";